export default "__VITE_ASSET__fnW$x9CL__"